import React from "react";
import { ButtonProp } from "./types";

import "./styles.scss";

const Button = ({
  type,
  name,
  subType,
  className,
  disabled,
  icon,
  onClick,
}: ButtonProp): JSX.Element => {
  return (
    <button
      disabled={disabled}
      type={type}
      onClick={onClick}
      className={`${subType ?? ""} ${className} button`}
    >
      {icon ? <img src={icon} alt="name" /> : ""}
      {name}
    </button>
  );
};

export default Button;
